module.exports = __webpack_public_path__ + "static/img/浙江纵海.8103a64.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/浙江纵海.jpg
// module id = RfFC
// module chunks = 1